/* Nurly — en-tête : sticky « visible quand on remonte », menus déroulants, tiroirs (menu / recherche),
   recherche prédictive (section FullStack `predictive-search`), compteur panier.
   Le panier lui-même est géré par les web components FullStack <cart-icon> / <cart-drawer>. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------- Tiroirs ---------- */
  var openDrawer = null;
  var lastTrigger = null;

  function setExpanded(id, value) {
    document.querySelectorAll('[aria-controls="' + id + '"][data-nhd-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function sectionOf(el) {
    return el.closest('.shopify-section');
  }

  function open(drawer, trigger) {
    if (!drawer || drawer === openDrawer) return;
    if (openDrawer) close(openDrawer, true);
    lastTrigger = trigger || document.activeElement;
    drawer.hidden = false;
    var section = sectionOf(drawer);
    if (section) section.classList.add('nhd-section--drawer-open');
    document.documentElement.style.overflow = 'hidden';
    // reflow pour lancer la transition
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    openDrawer = drawer;
    setExpanded(drawer.id, true);
    var focusTarget = drawer.querySelector('input[type="search"]') || drawer.querySelector('.nhd-drawer__panel');
    setTimeout(function () { if (focusTarget) focusTarget.focus({ preventScroll: true }); }, 50);
  }

  function close(drawer, immediate) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    setExpanded(drawer.id, false);
    if (openDrawer === drawer) openDrawer = null;
    var done = function () {
      if (drawer.classList.contains('is-open')) return;
      drawer.hidden = true;
      drawer.querySelectorAll('[data-nhd-subpanel]').forEach(function (p) { p.classList.remove('is-open'); p.hidden = true; });
      drawer.querySelectorAll('[data-nhd-sub]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var section = sectionOf(drawer);
      if (section && !openDrawer) section.classList.remove('nhd-section--drawer-open');
    };
    if (!openDrawer) document.documentElement.style.overflow = '';
    if (immediate) done(); else setTimeout(done, 300);
    if (!immediate && lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var opener = t.closest('[data-nhd-open]');
    if (opener) {
      e.preventDefault();
      open(document.getElementById(opener.getAttribute('data-nhd-open')), opener);
      return;
    }

    var closer = t.closest('[data-nhd-close]');
    if (closer && openDrawer && openDrawer.contains(closer)) {
      e.preventDefault();
      close(openDrawer);
      return;
    }

    var subBtn = t.closest('[data-nhd-sub]');
    if (subBtn) {
      var panel = document.getElementById(subBtn.getAttribute('data-nhd-sub'));
      if (panel) {
        panel.hidden = false;
        void panel.offsetWidth;
        panel.classList.add('is-open');
        subBtn.setAttribute('aria-expanded', 'true');
        var first = panel.querySelector('[data-nhd-back]');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
      }
      return;
    }

    var back = t.closest('[data-nhd-back]');
    if (back) {
      var sub = back.closest('[data-nhd-subpanel]');
      if (sub) {
        sub.classList.remove('is-open');
        var trigger = document.querySelector('[data-nhd-sub="' + sub.id + '"]');
        if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus({ preventScroll: true }); }
        setTimeout(function () { if (!sub.classList.contains('is-open')) sub.hidden = true; }, 300);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openDrawer) return;
    if (e.key === 'Escape') { close(openDrawer); return; }
    if (e.key === 'Tab') {
      var scope = openDrawer.querySelector('[data-nhd-subpanel].is-open') || openDrawer.querySelector('.nhd-drawer__panel');
      var items = Array.prototype.filter.call(scope.querySelectorAll(FOCUSABLE), function (el) {
        var sp = el.closest('[data-nhd-subpanel]');
        return el.offsetParent !== null && (!sp || sp === scope);
      });
      if (!items.length) return;
      var firstEl = items[0], lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }
  });

  // Si le panier FullStack s'ouvre, on ferme nos tiroirs
  document.addEventListener('cart:open', function () { if (openDrawer) close(openDrawer, true); });

  /* ---------- En-tête ---------- */
  class NurlyHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-nhd-bar]');
      this.section = this.closest('.shopify-section');
      this.sticky = this.dataset.sticky || 'none';
      this.lastY = window.scrollY;
      this.ticking = false;

      this.setHeightVar();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.setHeightVar.bind(this));
        this.ro.observe(this.bar);
      }

      if (this.sticky !== 'none') {
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.update();
      }

      this.initDropdowns();
      this.initCount();
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.ro) this.ro.disconnect();
      if (this.mo) this.mo.disconnect();
    }

    // Hauteur de ce qui précède l'en-tête (barre d'annonce…) — offsetTop n'est pas fiable sur un élément sticky
    topOffset() {
      var top = 0, el = this.section ? this.section.previousElementSibling : null;
      while (el) {
        if (el.offsetParent !== null || getComputedStyle(el).position === 'fixed') {
          var pos = getComputedStyle(el).position;
          if (pos !== 'fixed' && pos !== 'absolute') top += el.offsetHeight;
        }
        el = el.previousElementSibling;
      }
      return top;
    }

    setHeightVar() {
      if (!this.bar) return;
      document.documentElement.style.setProperty('--header-height', this.bar.offsetHeight + 'px');
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      var self = this;
      requestAnimationFrame(function () { self.update(); self.ticking = false; });
    }

    update() {
      var y = window.scrollY;
      var top = this.topOffset();
      var stuck = y > top;

      if (this.sticky === 'always') {
        this.classList.toggle('is-solid', stuck);
      } else if (this.sticky === 'scroll_up') {
        // Comme nurlyme.fr (mesuré PC et mobile) : fond blanc dès 300 px de défilement,
        // caché en descendant au-delà de 900 px, ré-affiché dès qu'on remonte.
        this.classList.toggle('is-solid', y >= 300);
        if (y >= 900 && y > this.lastY + 2) {
          if (!this.querySelector('.nhd__dd.is-open')) this.classList.add('is-hidden');
        } else if (y < 900 || y < this.lastY - 2) {
          this.classList.remove('is-hidden');
        }
      }
      this.lastY = y;
    }

    initDropdowns() {
      var self = this;
      var dds = this.querySelectorAll('[data-nhd-dd]');
      var closeAll = function (except) {
        dds.forEach(function (dd) {
          if (dd === except) return;
          dd.classList.remove('is-open');
          var b = dd.querySelector('.nhd__dd-toggle');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        self.classList.toggle('has-dd-open', !!except);
      };
      var setOpen = function (dd, value) {
        if (value) closeAll(dd); else { dd.classList.remove('is-open'); self.classList.remove('has-dd-open'); }
        dd.classList.toggle('is-open', value);
        var b = dd.querySelector('.nhd__dd-toggle');
        if (b) b.setAttribute('aria-expanded', value ? 'true' : 'false');
      };
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      dds.forEach(function (dd) {
        var timer;
        var btn = dd.querySelector('.nhd__dd-toggle');
        btn.addEventListener('click', function () { setOpen(dd, !dd.classList.contains('is-open')); });
        dd.addEventListener('mouseenter', function () { if (!canHover.matches) return; clearTimeout(timer); setOpen(dd, true); });
        dd.addEventListener('mouseleave', function () { if (!canHover.matches) return; timer = setTimeout(function () { setOpen(dd, false); }, 150); });
        dd.addEventListener('focusout', function (e) { if (!dd.contains(e.relatedTarget)) setOpen(dd, false); });
        dd.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dd.classList.contains('is-open')) { setOpen(dd, false); btn.focus(); } });
      });
      document.addEventListener('click', function (e) {
        if (!(e.target instanceof Element) || !e.target.closest('[data-nhd-dd]')) closeAll(null);
      });
    }

    initCount() {
      var wrap = this.querySelector('.nhd__count');
      var count = wrap && wrap.querySelector('[data-ref="cart-count"]');
      if (!count) return;
      var sync = function () { wrap.setAttribute('data-count', (count.textContent || '0').trim()); };
      this.mo = new MutationObserver(sync);
      this.mo.observe(count, { childList: true, characterData: true, subtree: true });
      sync();
    }
  }
  if (!customElements.get('nurly-header')) customElements.define('nurly-header', NurlyHeader);

  /* ---------- Recherche prédictive ----------
     Rendu comme nurlyme.fr : groupes (Produits, Collections…) en liste vignette + titre,
     puis bouton « Rechercher "terme" ». Données : /search/suggest.json, DOM construit sans innerHTML. */
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function chevronIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'nhd-svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var pl = document.createElementNS(SVG_NS, 'polyline');
    pl.setAttribute('points', '9 18 15 12 9 6');
    svg.appendChild(pl);
    return svg;
  }
  function safeUrl(u) {
    if (typeof u !== 'string') return null;
    if (u.charAt(0) === '/' && u.charAt(1) !== '/' && u.charAt(1) !== '\\') return u;
    try { var x = new URL(u, location.origin); return x.origin === location.origin ? x.pathname + x.search : null; } catch (e) { return null; }
  }
  function sizedImage(u) {
    if (typeof u !== 'string' || !u) return null;
    if (!/^(https:)?\/\//.test(u)) return null;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=150';
  }

  class NurlySearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="q"]');
      this.form = this.querySelector('form');
      this.results = this.querySelector('.nhd-search__results');
      this.popular = this.querySelector('[data-nhd-popular]');
      this.controller = null;
      var self = this, t;
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { self.search(self.input.value.trim()); }, 300);
      });
      if (this.form) this.form.addEventListener('reset', function () {
        setTimeout(function () { self.reset(); self.input.focus(); }, 0);
      });
    }

    reset() {
      if (this.controller) this.controller.abort();
      this.results.hidden = true;
      this.results.replaceChildren();
      if (this.popular) this.popular.hidden = false;
    }

    search(term) {
      var self = this;
      if (this.controller) this.controller.abort();
      if (!term) { this.reset(); return; }
      this.controller = new AbortController();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(term.slice(0, 120)) +
        '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: this.controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) { self.render(term, (data && data.resources && data.resources.results) || {}); })
        .catch(function (err) { if (err && err.name === 'AbortError') return; self.reset(); });
    }

    render(term, res) {
      var ds = this.dataset;
      var groups = [
        ['products', ds.labelProducts || 'Produits'],
        ['collections', ds.labelCollections || 'Collections'],
        ['pages', ds.labelPages || 'Pages'],
        ['articles', ds.labelArticles || 'Articles']
      ];
      var frag = document.createDocumentFragment();
      var count = 0;
      groups.forEach(function (g) {
        var items = Array.isArray(res[g[0]]) ? res[g[0]] : [];
        if (!items.length) return;
        var h = document.createElement('h4');
        h.className = 'nhd-search__heading';
        h.textContent = g[1];
        var ul = document.createElement('ul');
        ul.className = 'nhd-ps__list';
        ul.setAttribute('role', 'list');
        items.forEach(function (it) {
          var href = safeUrl(it.url);
          if (!href) return;
          var a = document.createElement('a');
          a.href = href;
          a.className = 'nhd-ps__item';
          var src = g[0] === 'products' ? sizedImage((it.featured_image && it.featured_image.url) || it.image) : null;
          if (src) {
            var img = document.createElement('img');
            img.className = 'nhd-ps__img';
            img.src = src;
            img.alt = '';
            img.width = 50;
            img.height = 63;
            img.loading = 'lazy';
            a.appendChild(img);
          } else {
            a.classList.add('nhd-ps__item--text');
          }
          var span = document.createElement('span');
          span.className = 'nhd-ps__text';
          span.textContent = it.title || '';
          a.appendChild(span);
          var li = document.createElement('li');
          li.appendChild(a);
          ul.appendChild(li);
          count++;
        });
        frag.appendChild(h);
        frag.appendChild(ul);
      });
      if (!count) {
        var p = document.createElement('p');
        p.className = 'nhd-search__empty';
        p.textContent = (ds.noResults || 'Aucun résultat pour « [terms] »').replace('[terms]', term);
        frag.appendChild(p);
      }
      var btn = document.createElement('button');
      btn.type = 'submit';
      btn.className = 'nhd-ps__term';
      if (this.form && this.form.id) btn.setAttribute('form', this.form.id);
      var lbl = document.createElement('span');
      lbl.textContent = (ds.searchFor || 'Rechercher "[terms]"').replace('[terms]', term);
      btn.appendChild(lbl);
      btn.appendChild(chevronIcon());
      frag.appendChild(btn);
      this.results.replaceChildren(frag);
      this.results.hidden = false;
      if (this.popular) this.popular.hidden = true;
    }
  }
  if (!customElements.get('nurly-search')) customElements.define('nurly-search', NurlySearch);

})();
